import { useEventListener } from '@socialive/common';
import PropTypes from 'prop-types';
import { useCallback, useEffect } from 'react';
import Modal from 'react-modal';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { ConnectionItemShape } from '../helpers/propTypeShapes';
import { deleteTraySolutionInstance, enableTraySolutionInstance } from '../store/connectionManager';

const customModalStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    padding: '0',
    textAlign: 'center',
    transform: 'translate(-50%, -50%)',
  },
  overlay: {
    backgroundColor: 'rgb(0,0,0,0.5)',
    zIndex: '3',
  },
};

export default function TrayEmbeddedModal({ isOpen, handleOnClose, instance }) {
  const dispatch = useDispatch();
  const handler = useCallback(
    ({ data }) => {
      if (data.type === 'tray.configPopup.error') {
        toast.error(`Something went wrong. Please try again.`);
        handleOnClose();
      }
      if (data.type === 'tray.configPopup.cancel') {
        if (!instance.enabled) {
          // if the instance is not enabled, it should be deleted from tray
          dispatch(
            deleteTraySolutionInstance({
              solutionInstanceId: instance.id,
              instanceTitle: instance.title,
              eventName: 'Add integration - Cancelled',
            })
          );
        }
        handleOnClose();
      }
      if (data.type === 'tray.configPopup.finish') {
        if (!instance.enabled) {
          dispatch(enableTraySolutionInstance({ solutionInstance: instance }));
        }
        const action = instance.enabled ? 'updated' : 'added';
        toast.success(`${instance.title} was ${action}.`);

        handleOnClose();
      }
    },
    [handleOnClose, dispatch, instance]
  );

  useEventListener('message', handler);

  useEffect(() => {
    Modal.setAppElement('body');
  }, []);

  return (
    <Modal isOpen={isOpen} style={customModalStyles}>
      <div className="connection-embedded-iframe">
        <iframe src={instance.trayWizardUrl} title="Tray" width="570" height="570" />
      </div>
    </Modal>
  );
}

TrayEmbeddedModal.propTypes = {
  instance: ConnectionItemShape.isRequired,
  isOpen: PropTypes.bool.isRequired,
  handleOnClose: PropTypes.func.isRequired,
};
